module.exports = __webpack_public_path__ + "img/completeIng.5a1d77fa.png";